import DashboardPage from "./DashboardPage";
import WorkflowDashboard from "../../components/Dashboard/WorkflowDashboard";

export default function DashboardsWorkflow() {
  return (
    <DashboardPage
      title="Fluxo de certificação"
      subtitle="Onde o processo trava e quanto tempo leva"
      info="As barras mostram o tempo médio parado em cada etapa; a etapa mais lenta (o gargalo) aparece destacada. Lead time = do início até 'auditado'. Retrabalho = certificados que precisaram de ajustes."
    >
      <WorkflowDashboard />
    </DashboardPage>
  );
}
